import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Button,
  Spinner,
  Modal,
  Table,
  Accordion,
  Tabs,
  Tab
} from "react-bootstrap";
import sections from "./BondDetailsSections";
import "../../styles/BondDetailsEdit.css";
import UploadModal from "../Modal/UploadModal";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getBondsDataService,
  getBondsDataByIdService,
  updateAttachmentOnBond,
  uploadBondDataService,
  getPresignedAttachmentUrl,
  deleteAttachmentOnBond,
} from "../../services/BondsServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserEdit, faFileEdit, faMailBulk, faShieldAlt, faHome } from "@fortawesome/free-solid-svg-icons";
import UserModal from "../Modal/UserModal";
import AttachmentTable from "../../components/AttachmentTable";
import {
  faPaperclip,
  faShield,
  faArrowLeft
} from "@fortawesome/free-solid-svg-icons";
import LawFirmModal from "../Modal/LawFirmModal";
import RelatedBondModal from "../Modal/RelatedBondModal";
import {
  isBondReviewUser,
  isMacUser,
  isDisabledBasedOnBusinessLogic,
  roleFilteredBondStatus,
  isTwbUser,
  isTeaUser,
  isBondCounselUser,
  isOfficeOfTheAttorneyGeneralUser
} from "../../services/AuthorizationRules";
import {
  USERS_TYPES,
  BOND_STATUS,
  SECURITY_TYPE,
  INTEREST_TYPE,
  INTEREST_RATE_VALUE,
  BOND_ACTION,
  BOND_STATUS_VALUE
} from "../../types";
import CurrencyInput from "../../components/CurrencyInput";
import { useOktaAuth } from "@okta/okta-react";
import DateLimitations from "../../components/DateLimitations";
import '../../styles/BondDetailsEdit.css';


const BondDetailsEdit = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const user = useSelector((state) => state.user);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [bondPageData, setBondPageData] = useState({});
  const [pendingBondStatusValue, setPendingBondStatusValue] = useState(null);
  const [autocompleteData, setAutocompleteData] = useState({});
  const [stepNo, setStepNo] = useState(1);
  const [isUpdated, setIsUpdated] = useState(false);
  const [show, setShow] = useState(false); // State for showing the modal
  const [alertMsg, setAlertMsg] = useState(false);
  const [statusMsg, setStatusMsg] = useState({});
  const [showEditBlockModal, setShowEditBlockModal] = useState(false);
  const [modelPopupMsg, setModelPopupMsg] = useState({});
  const [fieldname, setFieldname] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();
  // const role = JSON.parse(localStorage.getItem("userinfo"))?.role;
  const [sectionsData, setSelections] = useState({});
  const [bondStatusValue, setBondStatusValue] = useState("");

  const [showParaLegalUserPicker, setShowParaLegalUserPicker] = useState(false);
  const [selectedParaLegal, setSelectedParaLegal] = useState([]);

  const [showAagUserPicker, setShowAagUserPicker] = useState(false);
  const [selectedAagUser, setSelectedAagUser] = useState([]);

  const [showBondCounselUserPicker, setShowBondCounselUserPicker] =
    useState(false);
  const [selectedBondCounselUser, setSelectedBondCounselUser] = useState([]);

  const [showLegalAssistantUserPicker, setShowLegalAssistantUserPicker] =
    useState(false);
  const [selectedLegalAssistantUser, setSelectedLegalAssistantUser] = useState(
    []
  );

  const [showRelatedBondPicker, setShowRelatedBondPicker] = useState(false);
  const [selectedRelatedBond, setSelectedRelatedBond] = useState([]);

  const [attachmentOnBond, setAttachmentOnBond] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAttachment, setFilteredAttachment] = useState([]);
  const [attachmentToDelete, setAttachmentToDelete] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);

  const [showLawFirmPicker, setShowLawFirmPicker] = useState(false);
  const [selectedLawFirm, setSelectedLawFirm] = useState("");
  const [isBondStatusFocused, setIsBondStatusFocused] = useState(false);
  const [itsFixedInterestRate, setItsFixedInterestRate] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [maxDate, setMaxDate] = useState('');
  const [error, setError] = useState("");
  const [fieldsWithQuotes, setFieldsWithQuotes] = useState([]);
  const [showQuoteWarning, setShowQuoteWarning] = useState(false);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const bondsDaTableRef = useRef(null);
  const [activeTileIndex, setActiveTileIndex] = useState(-1);
  const [submitted, setSubmitted] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);


  const fieldDisplayNames = {
    Issuer: "Issuer",
    title: "Issuance Title",
    authority: "Authority",
    comments: "Comments",
    // add other fields if needed
  };

  const handleWarningClose = () => {
    setShowWarning(false)
  }

  const handleConfirmClose = () => {
    setShowConfirm(false)
  }

  const setData = (field, value, isInitial) => {
    let _bondPageData = bondPageData;
    console.log(bondPageData['bond_status'])
    if (field === 'twdb' && value && bondPageData['is_tea'] == '1') {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
        ['is_tea']: 0
      }
      setShowWarning(true)
    }
    else if (field === 'is_tea' && value && bondPageData['twdb'] == '1') {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
        ['twdb']: 0
      }
      setShowWarning(true)
    }
    else if (field === "bond_status") {
      return;
    }
    else {
      _bondPageData = {
        ..._bondPageData,
        [field]: value,
      }
    }
    setBondPageData(_bondPageData);
    if (!isInitial) {
      setSubmitted(false);
    }
  };

  useEffect(() => {
    const role = user.userinfo?.role;
    const roleData = sections[role]
    const sectionData = [];
    let publicSecurityInfo = [];
    let attachmentInfo = [];
    for (const item of roleData) {
      if (item.title === 'Public Security Information-I' || item.title === 'Public Security Information-II') {
        publicSecurityInfo = publicSecurityInfo.concat(item.fields)
      }
      else if (item.title === 'Attachments') {
        attachmentInfo = item.fields;
      }
      else {
        sectionData.push(item)
      }
    }

    const relatedBondsFields = publicSecurityInfo.filter((item) => item.name === 'related_bond')
    const publicSecurityInfoFields = publicSecurityInfo.filter((item) => item.name !== 'related_bond')
    console.log(bondPageData,'relatedBondsFields')

    sectionData.push({ title: 'Public Security Information', fields: publicSecurityInfoFields });
    sectionData.push({ title: 'Multiple Series', fields: relatedBondsFields });
    sectionData.push({ title: 'Attachments', fields: attachmentInfo });
    setSelections(sectionData);
  }, [user]);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      setIsLoggedIn(true)
    }
  }, [authState]);

  useEffect(() => {
    if (bondPageData["interest_type"] === INTEREST_RATE_VALUE.FIXED_INTEREST) {
      setItsFixedInterestRate(true);
    } else {
      setItsFixedInterestRate(false);
      bondPageData["fixed_interest_rate"] = 0;
    }
    setBondStatusValue(bondPageData.bond_status);
  }, [bondPageData["interest_type"]]);

  useEffect(() => {
    fetchBondPageData(id);
  }, [id]);

  useEffect(() => {
    const filteredData = attachmentOnBond?.filter((attachmentFiltered) =>
      attachmentFiltered.Attachment_Name.toLowerCase().includes(
        searchTerm.toLowerCase()
      )
    ) || [];
    setFilteredAttachment(filteredData);
  }, [attachmentOnBond, searchTerm]);

  // useEffect(() => {
  //   console.log("((((((((((((((((((((((((((((", BOND_STATUS);
  //   const statusObj = BOND_STATUS.find(
  //     (status) => status.label === bondPageData.bond_status
  //   );
  //   if (statusObj) {
  //     setBondStatusValue(statusObj.value);
  //   }
  // }, [bondPageData]);

  useEffect(() => {
    // const aagUser = selectedAagUser[0];
    setBondPageData((prevData) => ({
      ...prevData,
      aag_userinfo: selectedAagUser,
    }));
  }, [selectedAagUser]);

  useEffect(() => {
    // legal assistant
    //const legalAssistant = selectedLegalAssistantUser[0];

    setBondPageData((prevData) => ({
      ...prevData,
      legal_assistant_userinfo: selectedLegalAssistantUser,
    }));
  }, [selectedLegalAssistantUser]);

  useEffect(() => {
    setBondPageData((prevData) => ({
      ...prevData,
      paralegal_userinfo: selectedParaLegal,
    }));
  }, [selectedParaLegal]);

  useEffect(() => {
    setBondPageData((prevData) => ({
      ...prevData,
      bondcounsel_userinfo: selectedBondCounselUser,
    }));
  }, [selectedBondCounselUser]);

  useEffect(() => {
    setBondPageData((prevData) => ({
      ...prevData,
      law_firm: selectedLawFirm,
    }));
  }, [selectedLawFirm]);

  useEffect(() => {
    setBondPageData((prevData) => ({
      ...prevData,
      related_bonds: selectedRelatedBond,
    }));
  }, [selectedRelatedBond]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleOpenLawFirmModal = () => {
    setShowLawFirmPicker(true);
  };
  const handleOpenRelatedBondsModal = () => {
    setShowRelatedBondPicker(true);
  };
  const handleCloseRelatedBondModal = () => {
    setShowRelatedBondPicker(false);
  };

  const handleRequestDeleteConfirmation = async (attachment) => {
    setAttachmentToDelete(attachment);
    setShowDeleteConfirmation(true);
  };

  const handleShow = () => setShow(true);

  const handleClose = useCallback(() => {
    fetchBondPageData(id);
    setShow(false);
    setShowLoadingSpinner(true);
    const timer = setTimeout(() => {
      setShowLoadingSpinner(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, [id]);

  const hideAlertMsg = () => {
    navigate("/");
  };

  const closeReturnHome = () => {
    navigate("/");
  };

  const fetchBondPageData = async (bond_id) => {
    const bondResponse = await getBondsDataByIdService(
      bond_id,
      user.userinfo.email
    );
    console.log(bondResponse,'==>> bondResponse');
    setAttachmentOnBond(bondResponse?.Attachments);
    setBondPageData(bondResponse);
  };
  const handleApprovalToDelete = async () => {
    await handleDeleteAttachment(attachmentToDelete);
    setAttachmentToDelete({});
    await fetchBondPageData(id);
    setShowDeleteConfirmation(false);
  };

  const handleDeleteAttachment = async function (attachmentToDelete) {
    console.log(attachmentToDelete);
    attachmentToDelete.Is_Deleted_Flag = "Y";
    try {
      await Promise.all([
        deleteAttachmentOnBond(id, attachmentToDelete),
        updateAttachmentOnBond(attachmentToDelete),
      ]);
      console.log(`${attachmentToDelete.Attachment_Name} deleted successfully`);
      fetchBondPageData(id);
    } catch (error) {
      console.error("Error deleting attachment:", error);
    }
  };

  const handleDenialToDelete = async () => {
    setAttachmentToDelete({});
    setShowDeleteConfirmation(false);
    fetchBondPageData(id);
  };

  const handleStep = () => setStepNo(stepNo + 1);
  const previous = () => setStepNo(stepNo - 1);

  const handleOpenParaLegalUserModal = async () => {
    setShowParaLegalUserPicker(true);
  };
  const handleCloseParaLegalUserModal = async () => {
    setShowParaLegalUserPicker(false);
  };

  const handleOpenAagUserModal = async () => {
    setShowAagUserPicker(true);
  };
  const handleCloseAagUserModal = async () => {
    let _bondPageData = bondPageData
    if (bondPageData['bond_status'] === 'New') {
      _bondPageData = {
        ..._bondPageData,
        ['bond_status']: 'Under Review'
      }
    }
    setBondPageData(_bondPageData)
    setShowAagUserPicker(false);
  };

  const handleOpenLegalAssistUserModal = async () => {
    setShowLegalAssistantUserPicker(true);
  };
  const handleCloseLegalAssistUserModal = async () => {
    setShowLegalAssistantUserPicker(false);
  };

  const handleOpenBondCounselUserModal = async () => {
    setShowBondCounselUserPicker(true);
  };
  const handleCloseBondCounselUserModal = async () => {
    console.log("selectedBondCounselUser");
    console.log(selectedBondCounselUser);
    setShowBondCounselUserPicker(false);
  };

  const handleCloseLawFirmModal = () => {
    setShowLawFirmPicker(false);
  };
  const handleBondStatusChange = (e) => {
    const newValue = e.target.value;
    setData("bond_status", newValue);
    setBondStatusValue(newValue);
  };

  const handleBondStatusFocus = () => {
    setIsBondStatusFocused(true);
  };

  const handleBondStatusBlur = () => {
    setIsBondStatusFocused(false);
  };

  const homepage = () => navigate("/");
  const [disableFields, setDisableFields] = useState(false);
  const handleTranscriptCompleteChange = (fieldname, msg, value) => {
    console.log("Changing is_transcript_complete to:", value);
    if (value === "Yes") {
      setModelPopupMsg(msg);
      setFieldname(fieldname);
      setShowEditBlockModal(true);
    } else {
      if (!showEditBlockModal) {
        setDisableFields(false);
        setData(fieldname, value);
      }
    }
  };
  const prefill = (e) => {
    //console.log(e);
  };
  const handleModalYesClick = () => {
    console.log("inside handle YES");
    setDisableFields(true);
    setShowEditBlockModal(false);
    setData(fieldname, "Yes");
    //setData("is_transcript_complete", "Yes");
  };

  const handleModalNoClick = () => {
    setShowEditBlockModal(false);
    setData(fieldname, "No");
  };

  const handleBondSubmit = async () => {
    const textFields = ["Issuer", "title", "authority", "comments"];
    // Check for any fields containing a quotation mark (")
    // Find fields with quotes
    const fieldsWithQuotes = textFields.filter(
      (field) => bondPageData[field]?.includes('"')
    );

    if (fieldsWithQuotes.length > 0) {
      // Show modal with friendly field names
      setFieldsWithQuotes(fieldsWithQuotes.map(f => fieldDisplayNames[f] || f));
      setShowQuoteWarning(true);
      return; // stop save
    }
    
    if (pendingBondStatusValue !== null) {
      bondPageData.bond_status = BOND_STATUS.find((s) => s.value === pendingBondStatusValue)?.label;
    }
    setSubmitted(true);
    setIsUpdated(true);
    console.log("bond page data:", bondPageData);
    if(bondPageData["Issuer"] === "" || bondPageData["title"] === "" || bondPageData["closing_date"] === "mm/dd/yyyy") {
      setIsUpdated(false);
      setError(
          "Please Enter Mandatory fields"
      );
    }
    else if(bondPageData["par_dollar_amount"] > 0) {
      try {
        let bondPageDataToSave = { 
          ...bondPageData, 
          Issuer: bondPageData.Issuer?.replace(/\s+/g, " ").trim(),
          title: bondPageData.title?.replace(/\s+/g, " ").trim(),
          authority: bondPageData.authority?.replace(/\s+/g, " ").trim(),
          comments: bondPageData.comments?.replace(/\s+/g, " ").trim(),
          "bond_status": bondStatusValue 
        };
        console.log("Before API:", bondPageDataToSave, bondStatusValue);
        const uploaded_by = user?.userinfo?.email;
        bondPageDataToSave.email_address = uploaded_by;
        const responseData = await uploadBondDataService(bondPageDataToSave);
        console.log(responseData,bondPageDataToSave,'uploadBondDataService')
        setIsUpdated(false);

        setStatusMsg(
          "All the changes are saved successfully."
        );
        setAlertMsg(true);
      } catch (error) {
        setIsUpdated(false);
        setStatusMsg("An error occurred while saving the changes.");
        setAlertMsg(true);
      }
    }
    else {
      setIsUpdated(false);
      setError(
        "Par dollar amount value should be greater than Zero."
      );
    }
  };

  if (!isLoggedIn) {
    return navigate("/");
  }

  const handleCloseModal = () => {
    setActiveTileIndex(-1);
  }

  console.log(activeTileIndex)

  const iconList = {
    "Contact Information": faMailBulk,
    "Attachments": faPaperclip,
    "Public Security Information": faShieldAlt,
    "Public Security Information-I": faShield,
    "Public Security Information-II": faShield
  }

  if (bondPageData && JSON.stringify(bondPageData) === "{}") {
    return (
      <>
        <div>
          <div className="alert alert-warning">
            <strong>Warning! You Do not have access to this Bond </strong>
          </div>
        </div>
      </>
    );
  }

  const navigateBackToHome = () => {
    if (!submitted) {
      setShowConfirm(true);
      return
    }
    navigate(`/`);
  }

  const typeOfButton = (user, bondPageData) => {
    if(isOfficeOfTheAttorneyGeneralUser(user)) {
      if(bondPageData["bond_status"] === "New" || bondPageData["bond_status"] === "Under Review" || bondPageData["bond_status"] === "Delayed" || bondPageData["bond_status"] === "Registered" || bondPageData["bond_status"] === "Opinion Issued") {
        return (
          <Button
            onClick={handleBondSubmit}
            variant="primary"
            size="lg"
          >
            <p>Save</p> 
          </Button>
        )
      }
      else {
        return (
          <Button
            onClick={() => navigate(`/`)}
            variant="primary"
            size="lg"
          >
            <p>Close</p> 
          </Button>
        )}
    }
    if(isBondCounselUser(user)) {
      if(bondPageData["bond_status"] === "New" || bondPageData["bond_status"] === "Under Review") {
        return (
          <Button
            onClick={handleBondSubmit}
            variant="primary"
            size="lg"
          >
            <p>Save</p> 
          </Button>
        )
      }
      else {
        return (
          <Button
            onClick={() => navigate(`/`)}
            variant="primary"
            size="lg"
          >
            <p>Close</p> 
          </Button>
        )
      }
    }
    else {
      return (
        <Button
          onClick={() => navigate(`/`)}
          variant="primary"
          size="lg"
        >
          <p>Close</p> 
        </Button>
      )
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === '"') {
      e.preventDefault(); // prevent typing double quote
    }
  };

  return (
    <>
      <div className="bond-details-edit">
        {isUpdated && (
          <div className="update-message">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            <span>Updating...</span>
          </div>
        )}
        <div className="container">
          <div>
            <div className="title-tool-bar">
              <Button className="btn-back" onClick={navigateBackToHome}><span><FontAwesomeIcon icon={faHome} /></span> <span>Home</span></Button>
            </div>
            <div className="tile-details-container">
              <div><span className="tile-details-label">Issue#: </span>{bondPageData.bond_issue_number}</div>
              <div><span className="tile-details-label">Issuer: </span>{bondPageData.Issuer}</div>
              <div><span className="tile-details-label">Title: </span>{bondPageData.title}</div>
              <div><span className="tile-details-label">Status: </span>{bondPageData.bond_status}</div>
            </div>
            <Tabs defaultActiveKey="0">
              {sectionsData?.map((section, sectionIndex) => {
                return section.title !== "Attachments" ? (

                  <Tab eventKey={sectionIndex} title={section.title}>
                    <div className="form-group-container">
                      {error.length > 1 && section.title === "Public Security Information" ?
                          <div
                            className={
                              error.length ? "login-box col-6 mx-auto" : "login-box col-6 mx-auto"
                            }
                          >
                            {error.length ? (
                              <div className="alert alert-danger mt-3 mb-3">{error}</div>
                            ) : (
                              <div></div>
                            )}
                          </div> :
                          <div />
                      }
                      {
                        section.fields.map((field, fieldIndex) => {
                          const isVisible =
                            field.visible !== undefined ? field.visible : true;
                          let isEditable =
                            field.editable !== undefined ? field.editable : true;

                          if (
                            bondPageData.is_transcript_complete === "Yes" ||
                            bondPageData.is_opinion_complete === "Yes" ||
                            bondPageData.is_registration_complete === "Yes"
                          ) {
                            isEditable = false;
                          }
                          if (
                            bondPageData.is_transcript_complete === "Y" ||
                            bondPageData.is_opinion_complete === "Y" ||
                            bondPageData.is_registration_complete === "Y"
                          ) {
                            isEditable = false;
                          }
                          return isVisible ? (
                            <div key={fieldIndex} className={`form-group ${['Issuer', 'title', 'related_bond', 'comments'].includes(field.name) || section.title !== 'Public Security Information' && (!['law_firm'].includes(field.name)) ? 'full' : 'half'}`}>
                              {field.label !== 'Multiple Series' && (
                                <label className="form-label" style={{ fontSize: "0.9em" }}>
                                  {["Issuer", "Issuance Title","Par Dollar Amount ($)","Bond  Status","Closing Date"].includes(field.label)
                                    ? `${field.label}(*)`
                                    : field.label}
                                </label>
                              )}

                              {field.name === "is_transcript_complete" ||
                                field.name === "is_opinion_complete" ||
                                field.name === "is_registration_complete" ? (
                                <div className="input-group">
                                  <select
                                    value={bondPageData[field.name] || ""}
                                    onChange={(e) =>
                                      handleTranscriptCompleteChange(
                                        field.name,
                                        field.msg,
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    disabled={field.isDisabled}
                                  >
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                  </select>
                                </div>
                              ) : field.type === 'textarea' ?
                                <div className="input-group">
                                  <textarea value={bondPageData[field.name]}
                                    onChange={(e) =>
                                      setData(field.name, e.target.value)
                                    }
                                    onKeyDown={handleKeyDown}
                                    className="form-control"
                                    style={{ height: '100px' }}></textarea>
                                </div> :

                                field.type === "radio" ? (
                                  <div className="radio-group">
                                    {field.options.map((optionLabel, optionIndex) => {
                                      const optionValue =
                                        field.optionvalue[optionIndex];
                                      return (
                                        <label
                                          key={optionIndex}
                                          className="radio-label"
                                        >
                                          <div className="input-group">
                                            <span style={{ marginRight: "0.5em" }}>
                                              {optionLabel}
                                            </span>

                                            <input
                                              type="radio"
                                              name={field.name}
                                              value={optionValue}
                                              checked={
                                                bondPageData[field.name] == optionValue
                                              }
                                              onChange={(e) =>
                                                setData(
                                                  field.name,
                                                  parseInt(e.target.value)
                                                )
                                              }
                                              className="radio-input"
                                              disabled={isDisabledBasedOnBusinessLogic(
                                                user,
                                                bondPageData,
                                                field.name
                                              )}
                                            />
                                            <span className="radio-custom"></span>
                                          </div>
                                        </label>
                                      );
                                    })}
                                  </div>
                                ) : field.name === "security_type" ? (
                                  <div className="input-group">
                                    <select
                                      value={bondPageData["security_type"]}
                                      onChange={(e) =>
                                        setData("security_type", e.target.value)
                                      }
                                      className="form-control"
                                      disabled={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        "security_type"
                                      )}
                                    >
                                      {SECURITY_TYPE.map((status) => (
                                        <option key={status.value} value={status.value}>
                                          {status.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                ) : field.name === "interest_type" ? (
                                  <div className="input-group">
                                    <select
                                      value={bondPageData["interest_type"]}
                                      onChange={(e) =>
                                        setData("interest_type", e.target.value)
                                      }
                                      className="form-control"
                                      disabled={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        "interest_type"
                                      )}
                                    >
                                      {INTEREST_TYPE.map((status) => (
                                        <option key={status.value} value={status.value}>
                                          {status.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                ) : field.name === "bond_status" ? (
                                  <div className="input-group">
                                    <select
                                      value={bondStatusValue}
                                      onChange={handleBondStatusChange}
                                      className="form-control"
                                      onFocus={handleBondStatusFocus}
                                      onBlur={handleBondStatusBlur}
                                     disabled={
                                          !isBondCounselUser(user) &&
                                          bondPageData.bond_status === BOND_STATUS_VALUE.Delayed
                                            ? false
                                            : isOfficeOfTheAttorneyGeneralUser(user)
                                              ? bondPageData.bond_status === "Cancelled"
                                              : isDisabledBasedOnBusinessLogic(
                                                  user,
                                                  bondPageData,
                                                  "bond_status"
                                                )
                                      }
                                    >
                                      {(isBondStatusFocused
                                        ? roleFilteredBondStatus(user)
                                        : BOND_STATUS
                                      )?.map((status) => (
                                        <option key={status.value} value={status.value}>
                                          {status.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                ) : field.name === "traditional_or_conduit" ? (
                                  <div className="input-group">
                                    <select
                                      value={bondPageData["traditional_or_conduit"]}
                                      onChange={(e) =>
                                        setData(
                                          "traditional_or_conduit",
                                          e.target.value
                                        )
                                      }
                                      className="form-control"
                                      disabled={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        field.name
                                      )}
                                    >
                                      {" "}
                                      <option value="-1">Select Option</option>
                                      <option value="0">Traditional</option>
                                      <option value="1">Conduit</option>
                                    </select>
                                  </div>
                                ) : field.name === "Paralegal_Name" ? (
                                  <div className="input-group">
                                    {bondPageData["paralegal_userinfo"] &&
                                      bondPageData["paralegal_userinfo"].map(
                                        (userInfo, index) => (
                                          <div key={index}>
                                            <label
                                              key={index}
                                              title={
                                                "Email: " +
                                                userInfo.EmailID +
                                                "\nContact Phone: " +
                                                userInfo.office_phone
                                              }
                                              style={{
                                                display: "flex",
                                                marginRight: "10px", // Optional: add some space between labels
                                                padding: "6px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: !isDisabledBasedOnBusinessLogic(
                                                  user,
                                                  bondPageData,
                                                  field.name) ? "white" :
                                                  "#e9ecef"
                                              }}
                                            >
                                              {userInfo.FirstName + " " + userInfo.LastName}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    {!isDisabledBasedOnBusinessLogic(
                                      user,
                                      bondPageData,
                                      field.name
                                    ) && (
                                        <i onClick={handleOpenParaLegalUserModal}>
                                          <FontAwesomeIcon icon={faUserEdit} />
                                        </i>
                                      )}
                                  </div>
                                ) : field.name === "aag_name" ? (
                                  <div className="input-group">
                                    {bondPageData["aag_userinfo"] &&
                                      bondPageData["aag_userinfo"].map(
                                        (userInfo, index) => (
                                          <div key={index}>
                                            <label
                                              key={index}
                                              title={
                                                "Email: " +
                                                userInfo.EmailID +
                                                "\nContact Phone: " +
                                                userInfo.office_phone
                                              }
                                              style={{
                                                display: "flex",
                                                marginRight: "10px", // Optional: add some space between labels
                                                padding: "6px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: isBondCounselUser(user) ? "#e9ecef" : !isDisabledBasedOnBusinessLogic(
                                                  user,
                                                  bondPageData,
                                                  field.name) ? "white" :
                                                  "#e9ecef"
                                              }}
                                            >
                                              {userInfo.FirstName + " " + userInfo.LastName}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    {!isBondCounselUser(user) && !isDisabledBasedOnBusinessLogic(
                                      user,
                                      bondPageData,
                                      field.name
                                    ) && (
                                        <i onClick={handleOpenAagUserModal}>
                                          <FontAwesomeIcon icon={faUserEdit} />
                                        </i>
                                      )}
                                  </div>
                                ) : field.name === "legal_assistant" ? (
                                  <div className="input-group">
                                    {bondPageData["legal_assistant_userinfo"] &&
                                      bondPageData["legal_assistant_userinfo"].map(
                                        (userInfo, index) => (
                                          <div key={index}>
                                            <label
                                              key={index}
                                              title={
                                                "Email: " +
                                                userInfo.EmailID +
                                                "\nPhone: " +
                                                userInfo.Phone
                                              }
                                              style={{
                                                display: "flex",
                                                marginRight: "10px", // Optional: add some space between labels
                                                padding: "6px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: isBondCounselUser(user) ? '#e9ecef' : !isDisabledBasedOnBusinessLogic(
                                                  user,
                                                  bondPageData,
                                                  field.name
                                                ) ? 'white' : "#e9ecef",
                                              }}
                                            >
                                              {userInfo.FirstName + " " + userInfo.LastName}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    {!isBondCounselUser(user) && !isDisabledBasedOnBusinessLogic(
                                      user,
                                      bondPageData,
                                      field.name
                                    ) && (
                                        <i onClick={handleOpenLegalAssistUserModal}>
                                          <FontAwesomeIcon icon={faUserEdit} />
                                        </i>
                                      )}
                                  </div>
                                ) : field.name === "bond_counsel_name" ? (
                                  <div className="input-group">
                                    {bondPageData["bondcounsel_userinfo"] &&
                                      bondPageData["bondcounsel_userinfo"].map(
                                        (userInfo, index) => (
                                          <div key={index}>
                                            <label
                                              key={index}
                                              title={
                                                "Email: " +
                                                userInfo.EmailID +
                                                "\nContact Phone: " +
                                                userInfo.office_phone
                                              }
                                              style={{
                                                display: "flex",
                                                marginRight: "10px", // Optional: add some space between labels
                                                padding: "6px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: !isDisabledBasedOnBusinessLogic(
                                                  user,
                                                  bondPageData,
                                                  field.name
                                                ) ? 'white' : "#e9ecef",
                                              }}
                                            >
                                              {userInfo.FirstName + " " + userInfo.LastName}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    {!isDisabledBasedOnBusinessLogic(
                                      user,
                                      bondPageData,
                                      field.name
                                    ) && (
                                        <i onClick={handleOpenBondCounselUserModal}>
                                          <FontAwesomeIcon icon={faUserEdit} />
                                        </i>
                                      )}
                                  </div>
                                ) : field.name === "Issuer" ||
                                  field.name === "title" || field.name === "authority" ? (
                                  <div className="input-group">
                                    <input
                                      type={field.type}
                                      value={bondPageData[field.name] || ""}
                                      onChange={(e) =>
                                        setData(field.name, e.target.value)
                                      }
                                      className="form-control"
                                      disabled={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        field.name
                                      )}
                                      onKeyDown={handleKeyDown}
                                    />
                                  </div>
                                ) : field.name === "bond_issue_number" ? (
                                  <div className="input-group">
                                    <input
                                      type={field.type}
                                      value={bondPageData[field.name] || ""}
                                      onChange={(e) =>
                                        setData(field.name, e.target.value)
                                      }
                                      className="form-control"
                                      disabled={true}
                                    />
                                  </div>
                                ) : field.name === "fixed_interest_rate" ? (
                                  <div className="input-group">
                                    <input
                                      type={field.type}
                                      value={bondPageData["fixed_interest_rate"] || ""}
                                      onChange={(e) =>
                                        setData("fixed_interest_rate", e.target.value)
                                      }
                                      className="form-control"
                                      disabled={
                                        isDisabledBasedOnBusinessLogic(
                                          user,
                                          bondPageData,
                                          field.name
                                        ) || !itsFixedInterestRate
                                      }
                                    />
                                  </div>
                                ) : field.name === "par_dollar_amount" ||
                                  field.name === "fee_amount_due" ? (
                                  <div className="input-group">
                                    <CurrencyInput
                                      field={field.name}
                                      selectedData={bondPageData}
                                      setData={setData}
                                      isDisabledBasedOnBusinessLogic={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        field.name
                                      )}
                                    />
                                  </div>
                                ) : field.name === "law_firm" ? (
                                  <div className="input-group">
                                    <input
                                      disabled="true"
                                      readOnly
                                      type={field.type}
                                      value={bondPageData["law_firm"]}
                                      className="form-control"
                                    />
                                  </div>
                                ) : field.name === "issue_year" ? (
                                  <div className="input-group">
                                    <select
                                      value={bondPageData[field.name] || ""}
                                      onChange={(e) =>
                                        setData(field.name, e.target.value)
                                      }
                                      className="form-control"
                                      disabled={isDisabledBasedOnBusinessLogic(
                                        user,
                                        bondPageData,
                                        field.name
                                      )}
                                    >
                                      <option value="">Select Year</option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )
                                  : field.name === "closing_date" ? (
                                    <div className="input-group">
                                      <input
                                        type="date"
                                        value={bondPageData[field.name] || ""}
                                        onChange={(e) =>
                                          setData(field.name, e.target.value)
                                        }
                                        className="form-control"
                                        disabled={isDisabledBasedOnBusinessLogic(
                                          user,
                                          bondPageData,
                                          field.name
                                        )}
                                        min={new Date().toISOString().split("T")[0]}
                                        onKeyDown={(e) => e.preventDefault()}
                                        onChange={(e) => {
                                          console.log(e.target.value, 'inpur repsone')
                                          if (!/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) return;
                                          setData(
                                            "closing_date",
                                            e.target.value
                                          )
                                        }
                                        }
                                      />
                                    </div>
                                  )
                                    : field.name === "related_bond" ? (
                                      <div className="d-flex w-100 justify-content-center flex-column align-items-center">
                                        <Table ref={bondsDaTableRef} style={{ width: "75%", border: '2px solid #EDEDED' }}>
                                          <thead>
                                            <tr style={{ whiteSpace: "nowrap", fontSize: "0.9em" }}>
                                              <th className="no-resize">
                                                Title
                                              </th>
                                              <th className="no-resize">
                                                Issue Number
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {bondPageData["related_bonds"].filter(bond_number => bond_number.bond_issue_number !== bondPageData.bond_issue_number).map((bond) => (
                                              <tr key={bond.id}>
                                                <td className="no-resize">{bond.title}</td>
                                                <td className="no-resize">
                                                  {bond.bond_issue_number && (
                                                    <a
                                                      href={`/bond-details/${bond.bond_issue_number}/edit`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      {bond.bond_issue_number}
                                                    </a>
                                                  )}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                      </div>
                                    ) : (
                                      <>
                                        {(field.name === 'opinion_requested_by'
                                          || field.name === 'opinion_due_date' ||
                                          field.name === 'preliminary_letter_requested') ? <DateLimitations closingDate={bondPageData?.closing_date}
                                            onChangeHandler={(e) => setData(field.name, e.target.value)}
                                            valueData={bondPageData}
                                            fieldName={field.name}
                                            disabled={isDisabledBasedOnBusinessLogic(
                                              user,
                                              bondPageData,
                                              field.name
                                            )} /> :
                                          <div className="input-group">
                                            <input
                                              type={field.type}
                                              value={bondPageData[field.name] || ""}
                                              onChange={(e) =>
                                                setData(field.name, e.target.value)
                                              }
                                              className="form-control"
                                              disabled={isDisabledBasedOnBusinessLogic(
                                                user,
                                                bondPageData,
                                                field.name
                                              )}
                                            />
                                          </div>
                                        }
                                      </>
                                    )}
                            </div>
                          ) : null;
                        })
                      }
                    </div>
                    <div
                      className="d-flex flex-column align-items-center btn-container"
                      style={{ margin: '20px' }}
                    >
                      {!isDisabledBasedOnBusinessLogic(user, bondPageData, section.name) &&
                        section.title === 'Multiple Series' && (
                          <Button onClick={handleOpenRelatedBondsModal}>
                            <FontAwesomeIcon icon={faFileEdit} /> Update Related Bonds
                          </Button>
                        )}

                      {section.title === 'Public Security Information' && (
                        <p style={{color: "red"}}>** Warning! Do not enter any quotation marks in any field. Using quotation marks will create a coding conflict that will prevent further use of the TTR system. Contact  
                          <a className="btn-link" href="mailto:bond.registration@cpa.texas.gov"> bond.registration@cpa.texas.gov</a>.</p>
                      )}

                      {typeOfButton(user, bondPageData)}
                    </div>
                  </Tab>
                ) : (
                  <Tab eventKey={sectionIndex} title={section.title}>
                    <div key={sectionIndex}>
                      <AttachmentTable
                        showLoadingSpinner={showLoadingSpinner}
                        searchTerm={searchTerm}
                        handleSearch={handleSearch}
                        filteredAttachment={filteredAttachment}
                        setFilteredAttachment={setFilteredAttachment}
                        user={user}
                        bondPageData={bondPageData}
                        id={id}
                        handleRequestDeleteConfirmation={
                          handleRequestDeleteConfirmation
                        }
                      ></AttachmentTable>
                      <div className="d-flex justify-content-center">
                        {!isMacUser(user) && !isBondReviewUser(user) &&
                          !isDisabledBasedOnBusinessLogic(user, bondPageData, BOND_ACTION.UPLOAD) &&
                          (
                            <Button onClick={handleShow} variant="primary" size="lg">
                              Add Attachment
                            </Button>

                          )}
                      </div>
                    </div>
                  </Tab>
                )
              })}
            </Tabs>
          </div>

        </div>
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          aria-labelledby="contained-model-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title classprefix="model-title" as={"span"}>
              Add Attachment for {bondPageData.bond_counsel_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <UploadModal bond_id={id} handleClose={handleClose} />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
        <Modal
          show={alertMsg}
          onHide={hideAlertMsg}
          centered
          aria-labelledby="contained-model-title-vcenter"
        >
          <Modal.Header>
            <Modal.Title id="contained-model-title-vcenter">Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{statusMsg}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={hideAlertMsg}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showEditBlockModal}
          onHide={() => setShowEditBlockModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modelPopupMsg}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalNoClick}>
              No
            </Button>
            <Button variant="primary" onClick={handleModalYesClick}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Paralegal selection ------------------------- */}
        <Modal
          show={showParaLegalUserPicker}
          onHide={handleCloseParaLegalUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header closeButton>
            <div>
              Select {USERS_TYPES.PARA_LEGAL} User
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.PARA_LEGAL}
                existingUser={bondPageData["paralegal_userinfo"]}
                setUser={setSelectedParaLegal}
                setSubmitted={setSubmitted}
                onHide={handleCloseParaLegalUserModal}
                lawFirm={bondPageData["law_firm"]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* {This is to display if user inputs any " invalid fields in the text fields} */}
        {/* Quotation Mark Warning Modal */}
        <Modal
          show={showQuoteWarning}
          centered
          onHide={() => setShowQuoteWarning(false)}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
        >
          <Modal.Header closeButton>
            <div>Quotation Mark Warning</div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <p>
              Quotation marks (") are not allowed in any field. Please remove them
              before saving.
            </p>
            <div>
              <strong>Fields containing quotes:</strong>
              <ul>
                {fieldsWithQuotes.map((field, index) => (
                  <li key={index}>{field}</li>
                ))}
              </ul>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => setShowQuoteWarning(false)}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>


        {/* AAg selection ------------------------- */}
        <Modal
          show={showAagUserPicker}
          onHide={handleCloseAagUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header closeButton>
            <div>
              Select {USERS_TYPES.OAG} User
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.OAG}
                existingUser={bondPageData["aag_userinfo"]}
                setUser={setSelectedAagUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseAagUserModal}
                lawFirm={bondPageData["law_firm"]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* Legal assistant selection ------------------------- */}
        <Modal
          show={showLegalAssistantUserPicker}
          onHide={handleCloseLegalAssistUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header closeButton>
            <div>
              Select {USERS_TYPES.LEGAL_ASSISTANT} User
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.LEGAL_ASSISTANT}
                existingUser={bondPageData["legal_assistant_userinfo"]}
                setUser={setSelectedLegalAssistantUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseLegalAssistUserModal}
                lawFirm={bondPageData["law_firm"]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* BondCounsel selection ------------------------- */}
        <Modal
          show={showBondCounselUserPicker}
          onHide={handleCloseBondCounselUserModal}
          size="lg"
          dialogClassName="custom-modal-size select-user-modal"
          style={{ maxWidth: "90%", width: "90%" }}
        >
          <Modal.Header closeButton>
            <div>
              Select {USERS_TYPES.BOND_COUNSEL} User
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <div size="auto">
              <UserModal
                userIdentifier={USERS_TYPES.BOND_COUNSEL}
                existingUser={bondPageData["bondcounsel_userinfo"]}
                setUser={setSelectedBondCounselUser}
                setSubmitted={setSubmitted}
                onHide={handleCloseBondCounselUserModal}
                lawFirm={bondPageData["law_firm"]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* delete confirmation ------------------------- */}
        <Modal show={showDeleteConfirmation}>
          <Modal.Header>
            <div>
              Are you sure you want to Delete Attachment <br />
              <br />
              {attachmentToDelete.Attachment_Name}
            </div>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                type="button"
                class="btn btn-primary"
                onClick={() => handleDenialToDelete()}
              >
                No
              </button>
              <button
                type="button"
                class="btn btn-danger"
                onClick={() => handleApprovalToDelete()}
              >
                Yes
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {/* Law firm  selection ------------------------- */}
        <div>
          <Modal
            show={showLawFirmPicker}
            onHide={handleCloseLawFirmModal}
            size="lg"
            dialogClassName="custom-modal-size select-user-modal"
            style={{ maxWidth: "90%", width: "90%" }}
          >
            <Modal.Header closeButton>
              <div>
                Select Law Firm
              </div>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <div size="auto">
                <LawFirmModal
                  setLawFirm={setSelectedLawFirm}
                  onHide={handleCloseLawFirmModal}
                />
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </div>

        {/* Related Bond selection ------------------------- */}
        <div>
          <Modal
            show={showRelatedBondPicker}
            onHide={handleCloseRelatedBondModal}
            size="lg"
            dialogClassName="custom-modal-size select-user-modal"
            style={{ maxWidth: "90%", width: "90%" }}
          >
            <Modal.Header closeButton>
              <div>
                Select Related Bond
              </div>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <div size="auto">
                <RelatedBondModal
                  mainBondId={bondPageData["bond_issue_number"]}
                  existingRelatedBonds={bondPageData["related_bonds"]}
                  setRelatedBond={setSelectedRelatedBond}
                  onHide={handleCloseRelatedBondModal}
                />
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </div>
        <div>
          <Modal show={showWarning} centered onHide={handleWarningClose}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <div >
                <p>TX Water Development Board and TX Education Agency cannot have same value</p>
              </div>


            </Modal.Body>
          </Modal>
        </div>
        <div>
          <Modal show={showConfirm} centered onHide={handleConfirmClose}>
            <Modal.Header>
              <h3>Are you sure you want to exit?</h3>
            </Modal.Header>
            <Modal.Body>
              <div >
                <p>Are you sure you want to leave this page. Unsaved changes will be lost.</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="btn-container">
                <Button onClick={handleConfirmClose}>Cancel</Button>
                <Button onClick={() => { setSubmitted(true); navigate('/'); }}>Confirm</Button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </div >
    </>
  );
};

export default BondDetailsEdit;